import * as React from "react"
import { Grid, Typography, Box } from "@mui/material"
import {IconSeeker, TabsSeeker} from "@ui-seeker/core"
import { CardSeeker, CountUpSeeker, WidgetSeeker } from "@ui-seeker/core"


export default function SkuDetailsDistributionTabs({ tabs, tabSelected, onChange }) {
    return <TabsSeeker
        showTabID={tabSelected}
        onChange={onChange}
        tabs={(tabs || []).map(v => ({
            label: v.label,
            value: v.value
        }))}
        tabProps={{
            sx:{ p: 1, mt: 1, mb: 1, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 5px 20px' }
        }}
    />
}